<template>
    <vue-headful :title="'Callback ...'" description="title" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import CategoryService from '../../services/category'
import UserService from '../../services/users'
import DiagnosticoService from '../../services/diagnostic'
import MessageService from '../../services/message'
import AuthService from '../../services/auth'
import SurveyService from '../../services/survey'
import AvatarPackService from '../../services/avatarPack'

import parameters from "../../services/parameters";

import smartlookClient from 'smartlook-client'
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            avatar: (state) => state.userData.avatarSelected,
            selectedCategories: (state) => state.userData.selectedCategories,
            survey: (state) => state.userData.survey,
            testDiagnostic: (state) => state.dashboard.testDiagnostic,
            loadingState: (state) => state.loading,
            token: (state) => state.token,
            course: (state) => state.userData.user.course,
        }),
    },
    async created() {
        this.$loading(true)
        if ((this.$route.query.token && this.$route.query.token !== '') || !this.token) {
            this.resetState()
            this.resetUserState()
            this.resetDashboardState()
            this.setUserLoaded(false)
            const token = this.getUrlParameter('token')
            this.setToken(token)

            await AuthService.getInfoByToken()
                .then((response) => {
                    this.setUserData(response.content)
                    Sentry.setUser({ id: response.content.userId, username: response.content.username });
                })
                .catch((error) => {
                    console.error(error)
                    window.location.href = process.env.VUE_APP_BEEREADERS_LOGIN_URL
                })
        } else {
            window.location.href = process.env.VUE_APP_BEEREADERS_LOGIN_URL
        }
        Promise.all([
            CategoryService.getMetaDataCategory({ userId: this.user.id }),
            UserService.getUserSummaryInfoByUserId(this.user.id),
            DiagnosticoService.findDiagnosticoPendiente(this.user.id),
            SurveyService.findSurveyByUser(this.user.id),
            MessageService.getInboxMessages(this.user.id),
            AvatarPackService.getAvatarPackByName('Default-Pack'),
            parameters.getParameterByName(process.env.VUE_APP_PARAM_FOR_INITIAL_READER)
        ])
            .then((responseArray) => {
                let ChurnZero = window.ChurnZero || [];
                // Categorias
                this.changeCategories(responseArray[0].content)
                // Usuario
                this.setUserData(responseArray[1].content)

                // Diagnosticos pendientes
                this.setPendingDiagnosticData({
                    testDiagnostic: responseArray[2]?.content,
                    userId: this.user.id,
                })
                // Encuesta
                this.setSurvey(responseArray[3].content)

                // Mensajes
                this.setRecievedMessages(responseArray[4].content.content)

                this.setDefaultAvatarPack(responseArray[5].content)
                this.setUserLoaded(true)

                this.setDefaultAvatarPack(responseArray[5].content)

                this.setInitialReaderActive(responseArray[6].content?.value === 'YES');

                if (this.validateInitialTour()) {
                    this.initalTour()
                    this.$ga.event('pageLoaded', 'onboarding')
                    ChurnZero.push(['trackEvent', 'onboarding', 'Go to initial onboarding']);
                } else {
                    this.notStartTour()
                }

                this.$router.push('/user')
                const userIdentifier = {
                    "name": this.user.firstname,
                    "lastname": this.user.lastname,
                    "dni": this.user.dni,
                    "email": this.user.email,
                    "username": this.user.username,
                    "role": "STUDENT",
                    "school_name": this.user.school.name,
                    "school_id": this.user.school.id,
                    "course_id": this.user.course.id,
                    "course_name": this.user.course.name,
                }
                // Smartlook identifier
                smartlookClient.identify( this.user.id, userIdentifier);
                // ChurnZero identifier
                ChurnZero.push(['setAppKey', process.env.VUE_APP_CHURNZERO_APP_KEY]); // AppKey from ChurnZero
                ChurnZero.push(['setContact', userIdentifier.school_id, this.user.id]);
                ChurnZero.push(['setAttribute', 'account', {
                    Name: this.user.school.name,
                    IsDemo: this.user.school.rbd === 'demo'
                }])
                ChurnZero.push(['setAttribute', 'contact', {
                    FirstName: userIdentifier.name,
                    LastName: userIdentifier.lastname,
                    Email: userIdentifier.email,
                    CourseName: userIdentifier.course_name,
                    Dni: userIdentifier.dni,
                    Role: userIdentifier.role,
                    Username: userIdentifier.username
                }]);
                ChurnZero.push(['trackEvent', 'login', 'Login to the student platform']);
                this.$ga.event('pageLoaded', 'login')
            })
            .catch((error) => console.error('Error al obtener la data inicial', error))
            .finally(() => {
                this.$loading(this.loadingState)
            })
    },
    methods: {
        ...mapActions([
            'setToken',
            'resetState',
            'setLoadingState',
            'changeCategories',
            'setLinguisticVariables',
        ]),
        ...mapActions('common', ['setLinguisticVariables', 'setInitialReaderActive']),
        ...mapActions('userData', [
            'setUserData',
            'setUserLoaded',
            'setSurvey',
            'resetUserState',
            'setRecievedMessages',
        ]),
        ...mapActions('dashboard', [
            'initalTour',
            'setPendingDiagnosticData',
            'notStartTour',
            'setDefaultAvatarPack',
            'resetDashboardState',
        ]),
        getUrlParameter(sParam = '') {
            const sPageURL = window.location.search;
            const sURLVariables = new URLSearchParams(sPageURL);
            return sURLVariables.get(sParam)
        },
        validateInitialTour() {
            if (!this.avatar || !this.selectedCategories.length) return true;
            if (!this.isInitialReader && this.testDiagnostic && this.testDiagnostic.length) return true;
            return !this.isInitialReader && !!this.survey;

        },
    },
    mixins: [initialReaderValidation]
}
</script>
